export enum CostPeriodicityTypeEnum {
    ANNUAL = "annual",
    WEEKLY = "weekly",
    JOURNEY = "journey",
    SESSION = "session",
    MONTHLY = "monthly",
}

export class CostPeriodicityType {
    constructor(
        public readonly type: CostPeriodicityTypeEnum,
        public readonly label: string,
    ) {}
}
